import { useRef, useState } from "react";

import { ACCIDENTAL_ACTION_DEBOUNCE_TIME } from "app/pages/sales-intelligence/constants/timeouts";

type HookParams = {
    delay?: number;
};

export interface IUseTooltipDelayedState {
    isTooltipEnabled: boolean;
    onTooltipEnable: (tooltipEnableAction?: VoidFunction) => void;
    onTooltipDisable: (tooltipDisableAction?: VoidFunction) => void;
}

const useTooltipDelayedState = ({
    delay = ACCIDENTAL_ACTION_DEBOUNCE_TIME,
}: HookParams = {}): IUseTooltipDelayedState => {
    const delayTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

    const [isTooltipEnabled, setIsTooltipEnabled] = useState(false);

    const onTooltipEnable = (tooltipEnableAction?: VoidFunction): void => {
        delayTimer.current = setTimeout(() => {
            setIsTooltipEnabled(true);
            tooltipEnableAction?.();
        }, delay);
    };

    const onTooltipDisable = (tooltipDisableAction?: VoidFunction): void => {
        if (delayTimer.current) {
            clearTimeout(delayTimer.current);
            delayTimer.current = null;
        }

        if (isTooltipEnabled) {
            setIsTooltipEnabled(false);
            tooltipDisableAction?.();
        }
    };

    return {
        isTooltipEnabled,
        onTooltipEnable,
        onTooltipDisable,
    };
};

export default useTooltipDelayedState;
